/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/310-arrow-down-right': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 4.5l-4 4L3.5 0 0 3.5 8.5 12l-4 4H16V4.5z"/>'
  }
})
